export const transformObjectToDataGridRowsArray = <T extends object>(obj: T[]): Array<T & { id: string }> =>
  Object.entries(obj).map(([key, value]) => ({
    ...value,
    id: key,
  }));
